import { atom, useRecoilState, useResetRecoilState } from 'recoil'

import { localStorageEffect } from '@/capacitor/recoil/localstorage-effect'

const healthParameterUpdate = atom<{
  member?: number
  slug: string
  timestamp: number
}>({
  key: '@app/healthParamUpdate',
  default: undefined,
  effects: [localStorageEffect('@app/healthParamUpdate')],
})

export function useHealthParameterUpdate() {
  const [healthParameterUpdateState, setHealthParameterUpdateState] = useRecoilState(healthParameterUpdate)
  const resetHealthParameterUpdateState = useResetRecoilState(healthParameterUpdate)

  return {
    resetHealthParameterUpdateState,
    setHealthParameterUpdateState,
    healthParameterUpdateState,
  }
}
